import { Injectable } from "@angular/core";
import {
  DashboardCandidateBirthdayData,
  GetNewUiDashboardAnkaadiaUpdateGQL,
  GetNewUiDashboardCandidateBirthdaysGQL,
  GetNewUiDashboardCandidateEventsMetricGQL,
  GetNewUiDashboardCandidateStatesAtDateGQL,
  GetNewUiDashboardCandidateStatesGQL,
  GetNewUiDashboardOpenTasksMetricGQL,
  GetNewUiDashboardSharedCollectionsGQL,
  GetNewUiDashboardTalentPoolRequestsGQL,
  GetNewUiDashboardTalentPoolSharingsGQL,
  NewUiDashboardAnkaadiaUpdate,
  NewUiDashboardCandidateBirthdaysInput,
  NewUiDashboardCandidateEventsInput,
  NewUiDashboardCandidateEventsMetric,
  NewUiDashboardCandidateStateData,
  NewUiDashboardCandidateStatesAtDateInput,
  NewUiDashboardCandidateStatesInput,
  NewUiDashboardOpenTasksMetric,
  NewUiDashboardSharedCollection,
  NewUiDashboardTalentPoolRequests,
  NewUiDashboardTalentPoolSharings,
} from "@ankaadia/graphql";
import { map, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class NewUiDashboardService {
  constructor(
    private readonly metricsGet: GetNewUiDashboardOpenTasksMetricGQL,
    private readonly candidateEventsGet: GetNewUiDashboardCandidateEventsMetricGQL,
    private readonly candidateBirthdaysGet: GetNewUiDashboardCandidateBirthdaysGQL,
    private readonly ankaadiaUpdateGet: GetNewUiDashboardAnkaadiaUpdateGQL,
    private readonly candidateStatesGet: GetNewUiDashboardCandidateStatesGQL,
    private readonly candidateStatesAtDateGet: GetNewUiDashboardCandidateStatesAtDateGQL,
    private readonly sharedCollectionsGet: GetNewUiDashboardSharedCollectionsGQL,
    private readonly talentPoolRequestsGet: GetNewUiDashboardTalentPoolRequestsGQL,
    private readonly talentPoolSharingsGet: GetNewUiDashboardTalentPoolSharingsGQL
  ) {}

  getOpenTasksMetric(): Observable<NewUiDashboardOpenTasksMetric> {
    return this.metricsGet
      .fetch()
      .pipe(map((x) => x.data.getNewUiDashboardOpenTasksMetric as NewUiDashboardOpenTasksMetric));
  }

  getCandidateEventsMetric(input: NewUiDashboardCandidateEventsInput): Observable<NewUiDashboardCandidateEventsMetric> {
    return this.candidateEventsGet
      .fetch({ input })
      .pipe(map((x) => x.data.getNewUiDashboardCandidateEventsMetric as NewUiDashboardCandidateEventsMetric));
  }

  getCandidateBirthdays(input: NewUiDashboardCandidateBirthdaysInput): Observable<DashboardCandidateBirthdayData[]> {
    return this.candidateBirthdaysGet
      .fetch({ input })
      .pipe(map((x) => x.data.getNewUiDashboardCandidateBirthdays as DashboardCandidateBirthdayData[]));
  }

  getAnkaadiaUpdate(): Observable<NewUiDashboardAnkaadiaUpdate> {
    return this.ankaadiaUpdateGet
      .fetch()
      .pipe(map((x) => x.data.getNewUiDashboardAnkaadiaUpdate as NewUiDashboardAnkaadiaUpdate));
  }

  getCandidateStates(input: NewUiDashboardCandidateStatesInput): Observable<NewUiDashboardCandidateStateData[]> {
    return this.candidateStatesGet
      .fetch({ input })
      .pipe(map((x) => x.data.getNewUiDashboardCandidateStates as NewUiDashboardCandidateStateData[]));
  }

  getCandidateStatesAtDate(
    input: NewUiDashboardCandidateStatesAtDateInput
  ): Observable<NewUiDashboardCandidateStateData[]> {
    return this.candidateStatesAtDateGet
      .fetch({ input })
      .pipe(map((x) => x.data.getNewUiDashboardCandidateStatesAtDate as NewUiDashboardCandidateStateData[]));
  }

  getSharedCollections(hideEmptyLists: boolean): Observable<NewUiDashboardSharedCollection> {
    return this.sharedCollectionsGet
      .fetch({ input: { hideEmptyLists: hideEmptyLists } })
      .pipe(map((x) => x.data.getNewUiDashboardSharedCollections as NewUiDashboardSharedCollection));
  }

  getTalentPoolRequests(): Observable<NewUiDashboardTalentPoolRequests> {
    return this.talentPoolRequestsGet
      .fetch()
      .pipe(map((x) => x.data.getNewUiDashboardTalentPoolRequests as NewUiDashboardTalentPoolRequests));
  }

  getTalentPoolSharings(): Observable<NewUiDashboardTalentPoolSharings> {
    return this.talentPoolSharingsGet
      .fetch()
      .pipe(map((x) => x.data.getNewUiDashboardTalentPoolSharings as NewUiDashboardTalentPoolSharings));
  }
}
